import lc from '../../assets/imgs/lc.webp';
import eg from '../../assets/imgs/eg.webp';
import rs from '../../assets/imgs/rs.webp';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import CarouselArrow from '../../components/CarouselArrow';

const Branche = () => {
  return <section className='flex flex-col bg-empty text-white font-poppins py-20 gap-14'>
    <h1 className='text-center text-5xl'>Le branche</h1>
    <div className='text-center px-5 text-xl'>
      <p>Lo Scoutismo ha come punto cardine far vivere <b>esperienze ricche di significato</b> ad ogni educando/a.</p>
      <p className='mt-5 lg:mt-2'>Una volta dentro la grande famiglia degli Scout, inizia un <b>percorso sempre più profondo di Progressione</b></p>
      <p className='mt-5 lg:mt-2'><b>Personale</b>, articolata in Scoperta, Competenza e Responsabilità a più livelli attraverso le 3 branche.</p>
    </div>
    <div className='hidden lg:flex flex-row items-center justify-around'>
      <Link to={'branche/lc'} className="hover:scale-110 transition-[transform] duration-300 ease-out">
        <img className='max-h-64 w-auto h-auto object-contain' src={lc} alt='Lupetti e Coccinelle' width={228} height={300} loading="lazy" decoding="async" />
      </Link>
      <Link to={'branche/eg'} className="hover:scale-110 transition-[transform] duration-300 ease-out">
        <img className='max-h-64 w-auto h-auto object-contain' src={eg} alt='Esploratori e Guide' width={387} height={512} loading="lazy" decoding="async" />
      </Link>
      <Link to={'branche/rs'} className="hover:scale-110 transition-[transform] duration-300 ease-out">
        <img className='max-h-64 w-auto h-auto object-contain' src={rs} alt='Rover e Scolte' width={300} height={440} loading="lazy" decoding="async" />
      </Link>
    </div>
    <div className='lg:hidden px-4'>
      <Slider
        slide="1"
        swipe
        dots
        arrows
        className='overflow-y-visible'
        nextArrow={<CarouselArrow direction="right" />}
        prevArrow={<CarouselArrow direction="left" />}
      >
        <Link to={'branche/lc'}>
          <img className='max-h-64 w-full h-auto object-contain' src={lc} alt='Lupetti e Coccinelle' width={228} height={300} loading="lazy" decoding="async" />
        </Link>
        <Link to={'branche/eg'}>
          <img className='max-h-64 w-full h-auto object-contain' src={eg} alt='Esploratori e Guide' width={387} height={512} loading="lazy" decoding="async" />
        </Link>
        <Link to={'branche/rs'}>
          <img className='max-h-64 w-full h-auto object-contain' src={rs} alt='Rover e Scolte' width={300} height={440} loading="lazy" decoding="async" />
        </Link>
      </Slider>
    </div>
  </section>
};

export default Branche;